import genID from "./random";
import UploadFileTx from "./UploadFileTx";
function mediaUpInitTx(element, options){
  this.$element = $(element)
  this.options = {
    signatureUrl: 'appshortvideocb/getsignature', //腾讯获取验证信息的地址
    max: 1,
    type: 'img', //img 或 vedio
    field: '', //字段名称
    fieldId: '',//id字段名称
    needId: false, //是否需要id
    value: '', //初始值
    valueId: '', //初始值id
    width: 150
  }
  this.options = Object.assign(this.options, this.$element.data(), options)
  /******************上传初始化***********************/
  this.upload = new UploadFileTx(this.options, (file) => {
    const $item = $(`#${file.id}`);
    switch (file.state){
      case 'progress':
        $item.find('.progress-bar').css('width', file.progress)
        $item.find('.progress-text-num').text(file.progress)
        break;
      case 'success':
        $item.find('.media-con-progress').hide()
        let con;
        if(this.options.type=='img'){
          con = `<img src="${file.fileUrl}" alt="">`;
        } else {
          con = `<div class="v-center"><i class="iconfont icon-play icon-vedio"></i></div>`
        }
        $item.find('.media-con-media').html(con)
        $item.find('.media-con-media').show()
        $item.attr('res-url', file.fileUrl)
        $item.attr('res-id', file.fileId)
        this.calcValue();
        break
      case 'fail':
        $item.find('.media-con-progress').hide()
        $item.find('.media-con-media').html(`<div class="v-center text-secondary">上传失败</div>`)
        $item.find('.media-con-media').show()
        break
    }
  })

  /******************隐藏的表单值初始化***********************/
  let values = this.options.value;
  if(values){
    this.initValue();
  }
  this.$element.append(`<input type="hidden" name="${this.options.field}" value="${values}">`)
  if(this.options.needId){
    this.$element.append(`<input type="hidden" name="${this.options.fieldId}" value="${this.options.valueId}">`)
  }

  /******************input type=file element添加***********************/
  if(this.$element.find('input[role=file]').length===0){
    let multiple = ''
    let accept = ''
    if(this.options.accept){
      accept = this.options.accept;
    } else {
      // image/png, image/jpeg, image/jpg
      accept = this.options.type=='img'?'image/*':'video/*'
    }
    if(this.options.max > 1){
      multiple = 'multiple'
    }
    var input = `<input type="file" role="file" ${multiple} accept="${accept}">`
    this.$element.append(input)
  }
  const FILE_INPUT = this.$element.find(`input[role=file]`)
  const MEDIA_UP = this.$element.find('.media-up');
  MEDIA_UP.click(function (){
    $(FILE_INPUT[0]).click()
  })
  FILE_INPUT.change((e) => {
    var target = e.target;
    let hasLen = this.$element.find('.media-item.media-con').length;
    let canLen = this.options.max - hasLen
    if(canLen < 0) return
    let putLen = canLen;
    if(target.files.length < canLen){
      putLen = target.files.length;
    }
    for(let i=0; i < putLen; i++){
      let id = genID();
      this.upload.upFile({
        id,
        file: target.files[i]
      })
      canLen--;
      let width = this.options.width + 'px'
      let style=`width:${width}; height: ${width};`
      MEDIA_UP.before(`
          <div class="media-item media-con bg-light float-left" id="${id}" style="${style}">
            <div class="icon-close iconfont icon-close-o"></div>
            <div class="media-con-progress  v-center">
              <div class="progress v-center">
                <div class="progress-bar progress-bar-striped" role="progressbar" aria-valuenow="10" aria-valuemin="0" aria-valuemax="100"></div>
              </div>
              <div class="text-secondary text-center progress-text">已上传：<strong class="text-black progress-text-num">0</strong></div>
            </div>
            <div class="media-con-media"></div>
          </div>
      `)
      if(canLen>0){
        this.$element.find('.media-item.media-up').show()
      } else{
        this.$element.find('.media-item.media-up').hide()
      }
      var that = this;
      $(`[id="${id}"] .icon-close`).click(function (){
        that.actionDelete(`#${id}`)
      })
    }
    target.value = ''
  })
}
mediaUpInitTx.prototype.actionDelete = function (elem){
  $(elem).remove()
  let hasLen = this.$element.find('.media-item.media-con').length;
  let canLen = this.options.max - hasLen
  if(canLen>0){
    this.$element.find('.media-item.media-up').show()
  } else{
    this.$element.find('.media-item.media-up').hide()
  }
  this.calcValue();
}
mediaUpInitTx.prototype.calcValue = function (){
  let ids = []
  let files = [];
  this.$element.find('.media-item.media-con').each(function (){
    if($(this).attr('res-url')){
      files.push($(this).attr('res-url'))
    }
    if($(this).attr('res-id')){
      ids.push($(this).attr('res-id'))
    }
  })
  let values = files.join(',')
  let valuesId = ids.join(',');
  this.$element.find(`input[name=${this.options.field}]`).val(values)
  if(this.options.needId){
    this.$element.find(`input[name=${this.options.fieldId}]`).val(valuesId)
  }

}
mediaUpInitTx.prototype.initValue = function (){
  let that = this;
  let value = this.options.value + '';
  let valueId = this.options.valueId + '';
  const MEDIA_UP = this.$element.find('.media-up');
  if(value){
    value = value.split(',')
    if(this.options.needId){
      valueId = valueId.split(',')
    }
    let width = this.options.width + 'px'
    let style=`width:${width}; height: ${width};`
    for(let i=0;i<value.length;i++){
      let id = genID()
      let vid ='' ;
      if(valueId.length == value.length){
        vid = valueId[i]
      }
      var con = ''
      if(this.options.type=='img'){
        con = `<img src="${value[i]}" alt="">`;
      } else {
        con = `<div class="v-center"><i class="iconfont icon-play icon-vedio"></i></div>`
      }
      MEDIA_UP.before(`
          <div class="media-item media-con bg-light float-left" id="${id}" res-url="${value[i]}" res-id="${vid}" style="${style}">
            <div class="icon-close iconfont icon-close-o"></div>
            <div class="media-con-media">${con}</div>
          </div>
      `)
      $(`[id="${id}"] .icon-close`).click(function (){
        that.actionDelete(`#${id}`)
      })

    }
    this.$element.find('.media-con-media').show()
  }
  this.calcValue();
  let len = this.$element.find('.media-item.media-con').length
  if(len < this.options.max){
    this.$element.find('.media-item.media-up').show()
  } else{
    this.$element.find('.media-item.media-up').hide()
  }
}
export default mediaUpInitTx
